import LinkInstrumentCard from '@BUP/components/Generics/Cards/InstrumentCard/link-instrument-card'
import { isSociogram } from '@BUP/services/BraveUp'
import SociogramImage from '@BUP/assets/Images/Data/sociogram_image.svg'
import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { OrganizationContext } from '@BUP/contexts/OrganizationContext'
import InfoInstrumentCard from '@BUP/components/Generics/Cards/InstrumentCard/info-instrument-card'
import { useNavigate } from 'react-router-dom'

const SociogramECEInstrumentCard = () => {
  const i18n = useTranslation()
  const navigate = useNavigate()
  const organization = useContext(OrganizationContext)

  if (isSociogram(organization)) {
    return (
      <div>
        <LinkInstrumentCard
          srcImage={SociogramImage}
          title={i18n.t('pages.data.instruments.counselor.sociogram.title')}
          description={i18n.t('pages.data.instruments.counselor.sociogram.description')}
          onClick={() => navigate('/sociogram')}
        />
      </div>
    )
  }
  return (
    <div className='info_instrument_card_ece'>
      <InfoInstrumentCard
        srcImage={SociogramImage}
        title={i18n.t('pages.data.instruments.counselor.sociogram.title')}
        description={i18n.t('pages.data.instruments.counselor.sociogram.description')}
      />
    </div>
  )
}

export default SociogramECEInstrumentCard
